import * as $ from 'jquery';

export default class AsyncRender {
  static NAMESPACE = 'axel-async-render';

  public label;
  private opts;

  public constructor(renderer, opts = {}) {
    this.label = 'async-render';
    this.opts = opts;
  }

  /**
   * [HookMethod] Before Render
   *
   * @param tableEl
   * @param containerEl
   * @returns {any}
   */
  public beforeRender(tableEl, containerEl) {
    if (this.dimensionsAtCapacity(containerEl)) {
      this.hideRows(tableEl);
    }
    return tableEl;
  }

  /**
   * [HookMethod] After Render
   *
   * @param tableEl
   * @param containerEl
   * @returns {any}
   */
  public afterRender(tableEl, containerEl) {
    if (this.dimensionsAtCapacity(containerEl)) {
      this.revealRowsAsync(tableEl);
    }
    return tableEl;
  }

  /**
   * Hide Rows
   *
   * @param tableEl
   */
  private hideRows(tableEl) {
    $(tableEl).find('tbody tr').hide();
  }

  /**
   * Reveal Rows Async
   *
   * @param tableEl
   */
  private revealRowsAsync(tableEl) {
    const incNum = 100;
    const $tbody = $(tableEl).find('tbody');
    const $rows = $tbody.find('tr');
    const frag = document.createDocumentFragment();
    const rowLength = $rows.length;
    const context = this;
    const inc = (count, max, incNum) => {
      if (count > max || count === max) {
        return max;
      }
      if (count < max && count + incNum < max) {
        return count + incNum;
      }
      if (count < max && count + incNum > max) {
        return max;
      }
    };
    const showRows = function showRows(count, length) {
      const start = count > incNum ? count : 0;
      const end = inc(count, rowLength, incNum);

      $rows
        .slice(start, end)
        .show()
        .toArray()
        .forEach((rowEl) => {
          frag.appendChild(rowEl);
        });

      $tbody.get(0).appendChild(frag);

      if (end < rowLength) {
        setTimeout(showRows.bind(context, end, length), 100);
      }
    };
    $rows.remove();
    showRows(0, $rows.length);
  }

  private dimensionsAtCapacity(containerEl) {
    return this.opts.dimensionsAtCapacity && this.opts.dimensionsAtCapacity(containerEl);
  }
}
